import { getData } from '../modules/fetch';

const getStores = (callback) => {
  getData('/stores/listings/1,999')
    .then((data) => {
      if (data)
        callback(Object.values(data.data) as any);
    })
    .catch((err) => {
      console.error(err);
    });
}

export default getStores;
